import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const Footer = () => (
  <footer className="border-t border-[#D8D2C7] mt-24 md:mt-32" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-16 md:py-24">
      <Reveal>
        <p className="font-mono text-[10px] md:text-xs tracking-[0.25em] text-[#6E6B65]">
          GET IN TOUCH
        </p>
        <a
          href="mailto:chriscollins7887@gmail.com"
          data-testid="footer-email-cta"
          className="group mt-6 inline-flex items-baseline gap-3 font-serif text-[11vw] md:text-[6.5vw] leading-none tracking-[-0.03em] text-[#1A1918] hover:text-[#C85A32] transition-colors duration-500"
        >
          Let’s talk
          <ArrowUpRight
            className="inline-block w-[0.6em] h-[0.6em] transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2"
            strokeWidth={1.5}
          />
        </a>
        <p
          className="mt-5 font-mono text-[11px] md:text-xs tracking-[0.22em] text-[#6E6B65]"
          data-testid="footer-email-text"
        >
          CHRISCOLLINS7887@GMAIL.COM
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 font-sans tracking-[0.18em] text-[11px] md:text-xs text-[#1A1918]">
          <a
            href="mailto:chriscollins7887@gmail.com"
            data-testid="footer-link-email"
            className="link-sweep py-1"
          >
            EMAIL
          </a>
          <a
            href="https://www.linkedin.com/in/chris-collins-4b4442421/"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-link-linkedin"
            className="link-sweep py-1"
          >
            LINKEDIN
          </a>
          <a
            href="/christopher-collins-resume.pdf"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-link-resume"
            className="link-sweep py-1"
          >
            RESUME
          </a>
        </div>
      </Reveal>
      <div className="mt-16 pt-6 border-t border-[#E2DDD5] flex flex-wrap justify-between gap-3 font-mono text-[10px] tracking-[0.22em] text-[#99958D]">
        <span data-testid="footer-copyright">© 2026 CHRISTOPHER COLLINS</span>
        <span>PRODUCT / UX / BRAND</span>
        <span data-testid="footer-location">RENO, NEVADA</span>
      </div>
    </div>
  </footer>
);
